<template>
    <div id="fluke-menu" class="container">
        <router-link
            v-for="(item,index) in links"
            :key="index"
            :to="'/' + item.to">

            <i class="material-icons">{{item.icon}}</i>

            {{item.title}}
        </router-link>
    </div>
</template>

<script>
import permission from '../../../mixins/permissions';

export default {
    mixins: [ permission ],
    data: function()
    {
        return {
            links: [
                {
                    to: '',
                    title: 'Home',
                    icon: 'home'
                },
                {
                    to: 'courses',
                    title: 'Cursos',
                    icon: 'school'
                },
                {
                    to: 'faq',
                    title: 'FAQ',
                    icon: 'question_answer'
                },
                {
                    to: 'events',
                    title: 'Eventos',
                    icon: 'event_available'
                },
                {
                    to: 'blog',
                    title: 'Blog',
                    icon: 'chrome_reader_mode'
                },
                {
                    to: 'newsletter',
                    title: 'Newsletter',
                    icon: 'local_post_office'
                },
                {
                    to: 'contacts',
                    title: 'Contatos',
                    icon: 'contacts'
                },
                {
                    to: 'pages',
                    title: 'Páginas',
                    icon: 'view_compact'
                },
                {
                    to: 'menu',
                    title: 'Menu',
                    icon: 'menu'
                },
                {
                    to: 'images',
                    title: 'Imagens',
                    icon: 'collections'
                },
                {
                    to: 'students',
                    title: 'Alunos',
                    icon: 'people'
                },
                {
                    to: 'students_terms',
                    title: 'Termo de Consentimento',
                    icon: 'people'
                },
                {
                    to: 'user_logs',
                    title: 'Logs do sistema',
                    icon: 'list'
                },
            ]
        }
    },
    created: function(){
        this.updateLinks();
    },
    updated: function() {
        this.updateLinks();
    },
    methods: {
        updateLinks: function() {
            this.links = this.links.filter( el => {
                const permission  = this.getUserPagePermission( el.to );
                return permission && permission.read;
            });
        }
    }
}
</script>


<style lang="scss">
#fluke-menu {
    padding: 0 45px;

	a {
		font-size: 18px;
		text-decoration: none;
		text-rendering: optimizeLegibility;
        color: #bdbdbd;
        display: block;

        border: rgba(255,255,255,0.1) solid;
        border-width: 0 0 1px 0;
        padding: 10px 0 10px 30px;
        font-size: 16px;

        position: relative;

        &:hover
        {
			color: #ffffff;

            i {
                color: #ffffff;
            }
		}
        &.router-link-exact-active
        {
			color: $menu-accent-color;

            i {
    			color: $menu-accent-color;
            }
		}

        &.router-link-exact-active::after
        {
            content: '\0276D';
            font-size: 10px;
            position: absolute;
            right: 0;
            top: 13px;
        }

        &:last-child
        {
            border: none;
        }

        i {
            position: absolute;
            font-size: 18px;
            top: 11px;
            left: 0;
            color: #585858;
        }
	}
}
</style>
